import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImagePortrait = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29 9H11V31H29V9Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 28.1818L16.7273 22.4545L19.5909 25.3182L24.5 20.4091L29 24.9091",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8975 18.5782C18.9141 18.5782 19.7383 17.7299 19.7383 16.6834C19.7383 15.637 18.9141 14.7887 17.8975 14.7887C16.8808 14.7887 16.0566 15.637 16.0566 16.6834C16.0566 17.7299 16.8808 18.5782 17.8975 18.5782Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgImagePortrait);
export default ForwardRef;
